// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-timeline{margin:0;font-size:14px;list-style:none}.el-timeline .el-timeline-item:last-child .el-timeline-item__tail{display:none}", ""]);
// Exports
module.exports = exports;
